import { IWindow, IWindowActions, WindowActions } from './IWindow';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { AfterViewInit, Component, ElementRef, EventEmitter, Inject, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { Util } from '@phdsoft/common';
import { Subscription } from 'rxjs';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'phdsoft-window',
  templateUrl: './window.component.html'
})
export class WindowComponent implements OnInit, AfterViewInit, OnDestroy {

  dragPosition = { x: 0, y: 0 };

  @Input() options: IWindow;
  @Input() loading = false;
  @Input() okDisabled: boolean;


  get okButtonDisabled(): boolean {
    return this.okDisabled;
  }

  get isOffline() {
    return !window.navigator.onLine
  }

  @Output() cancel: EventEmitter<IWindowActions> = new EventEmitter<IWindowActions>();
  @Output() ok: EventEmitter<IWindowActions> = new EventEmitter<IWindowActions>();
  @Output() MaximizedMobile: EventEmitter<IWindowActions> = new EventEmitter<IWindowActions>();
  @Output() edit: EventEmitter<IWindowActions> = new EventEmitter<IWindowActions>();


  @ViewChild('divWindow') divWindow: ElementRef<HTMLDivElement>;

  sub: Subscription;
  width: number;
  height: number;

  constructor(
    private readonly breakpointObserver: BreakpointObserver,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
  }

  ngAfterViewInit(): void {
    if (this.divWindow) {
      this.width = this.divWindow.nativeElement.clientWidth;
      this.height = this.divWindow.nativeElement.clientHeight;
    }

    this.sub = this.breakpointObserver
      .observe([Breakpoints.Small])
      .subscribe((result) => {
        if (result.matches) {
          this.dragPosition = this.getDefaultPosition(window.innerWidth, window.innerHeight, true);
        } else {
          this.dragPosition = this.getDefaultPosition(window.innerWidth, window.innerHeight);
        }
      });
  }

  ngOnInit(): void {
  }

  getDefaultPosition(innerWidth: number, innerHeight: number, isMobile = false): any {

    let ret = { x: (innerWidth / 2) - 130, y: (window.innerHeight / 2) - 130 };

    switch (this.options.Position) {
      case 'zero':
        ret = { x: 10, y: 20 };
        break;
      case 'top center':
        ret = { x: (innerWidth / 2) - 130, y: 40 };
        break;
      case 'center':
        ret = { x: (innerWidth / 2) - (this.width / 2), y: (window.innerHeight / 2) - (this.height / 2) };
        break;
      case 'left center':
        ret = { x: 4, y: 80 };
        break;
      case 'left start':
        ret = { x: 70, y: 80 };
        break;
      case 'right center':
        ret = { x: innerWidth - 275, y: 120 };
        break;
      case 'right start':
        ret = { x: innerWidth - 290, y: 40 };
        break;
      case 'center byMenu':
        ret = { x: (innerWidth / 4) + 22, y: window.innerHeight / 6 };

        if (isMobile) {
          ret = { x: -3, y: 90 };
        } else if (Util.isMobile()) {
          ret = { x: -3, y: 90 };
        }
        break;
        case 'favorite':
          ret = {x: innerWidth - 325, y: 90};

        break;
        case 'favorite-rs':
          ret = {x: innerWidth - 380, y: 90};

        break;

        case 'miniWindow':
          ret = {x: innerWidth - 180, y: 85};

        break;



      default:
        ret = { x: (innerWidth / 2) - 170, y: (innerHeight / 2) - 160 };
        break;

    }
    return ret;

  }

  onResize(event): void {
    this.dragPosition = this.getDefaultPosition(event.target.innerWidth, event.target.innerHeight);
  }

  onOk(): void {
    // this.loading = true;
    this.ok.emit({ Action: WindowActions.Ok, Event: this.data });
  }

  onCancel(event: string): void {
    this.options.isMinimized = !this.options.isMinimized;
    this.cancel.emit({ Action: event as WindowActions, Event: this.options.isMinimized });
  }

  onEdit(): void {
    this.edit.emit({ Action: WindowActions.Edit, Event: this.data });
  }

  ngOnDestroy(): void {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }
}
